import { Container, type ContainerProps } from '@mui/material';
import { composeSx } from '../../utils/composeSx';

export type HFPageContainerProps = ContainerProps;

/**
 * Page inset — 24px all around; roomier bottom on desktop.
 *
 * Shared spacing scale (4px grid):
 * 24px between major page blocks, 16px between tiles inside a card,
 * 8px between compact rows / form fields.
 */
export function HFPageContainer({ children, maxWidth = 'lg', sx, ...props }: HFPageContainerProps) {
  return (
    <Container
      maxWidth={maxWidth}
      sx={composeSx(
        {
          p: 3,
          pb: { xs: 3, md: 6 },
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          width: '100%',
        },
        sx,
      )}
      {...props}
    >
      {children}
    </Container>
  );
}
